import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Select,
  VStack,
} from "@chakra-ui/react";
import { cqAPI } from "../../lib/Auth";
import ClientTokenSettings from "./ClientTokenSettings";

const PracticeManagementSoftware = () => {
  const [pmsOptions, setPmsOptions] = useState({});
  const [selectedPMS, setSelectedPMS] = useState("");
  const [workerType, setWorkerType] = useState("");
  const [pmsType, setPMSType] = useState("");
  const [supportedPMSVersions, setSupportedPMSVersions] = useState([]);
  const [pmsVersion, setPmsVersion] = useState("");
  const [configs, setConfigs] = useState([]);
  const [business, setBusiness] = useState({});
  const [supportedPMS, setSupportedPMS] = useState({});
  const [unusedPMS, setUnusedPMS] = useState({});

  const fetchClientConfig = async () => {
    const config = await cqAPI.get("/settings/client");
    const configs = config?.data?.configs || [];
    const supportedPMS = config?.data?.SUPPORTED_PMS || {};
    setPmsOptions(config?.data);
    setConfigs(configs);
    setBusiness(config?.data?.business || []);
    setSupportedPMS(supportedPMS);

    const selectablePMS = Object.fromEntries(Object.entries(supportedPMS).filter(
      ([, entry]) => !configs.find(
        (config) => entry.worker_type === config.worker_type && entry.pms_type === config.pms_type
      )
    ));

    setUnusedPMS(selectablePMS);
  };

  useEffect(() => {
    fetchClientConfig();
  }, []);

  const postMultipleClientFields = async (value) => {
    await cqAPI.post("/settings/client", value);
    await fetchClientConfig();
    return true;
  };

  const selectPMS = (pmsName) => {
    const pms = pmsOptions?.SUPPORTED_PMS[pmsName];
    if (!pms) {
      setSelectedPMS("");
      setWorkerType("");
      setPMSType("");
      setSupportedPMSVersions([]);
      return;
    }
    setSelectedPMS(pmsName);
    setSupportedPMSVersions(pms.versions);
    setWorkerType(pms.worker_type);
    setPMSType(pms.pms_type);
    if (pmsName !== selectedPMS) {
      if (pms.versions.length) {
        setPmsVersion(pms.versions[0]);
      } else {
        setPmsVersion("");
      }
    }
  };

  const addNewClient = async () => {
    if (!workerType || !pmsType) {
      return;
    }
    if (supportedPMSVersions.length && !pmsVersion) {
      return;
    }
    await postMultipleClientFields({
      worker_type: workerType,
      pms_type: pmsType,
      pms_version: pmsVersion
    });
  };

  return (
    <Box p={4} overflowY="auto" w="100%">
      <VStack spacing={4} align="stretch">
        <Flex alignItems="center" justifyContent="flex-start">
          <Select
            placeholder="Select PMS"
            onChange={(e) => selectPMS(e.target.value)}
            value={selectedPMS}
            width="initial" // Control the width as needed
          >
            {unusedPMS &&
              Object.entries(unusedPMS).map(
                ([key]) => (
                  <option key={key} value={key}>
                    {key}
                  </option>
                )
              )}
          </Select>
          {!!supportedPMSVersions.length && (
            <Select
              value={pmsVersion}
              width="initial" // Control the width as needed
              onChange={(e) => setPmsVersion(e.target.value)}
            >
              {/* Dynamically generate version options based on pmsOptions */}
              {supportedPMSVersions.map((version, index) => (
                <option key={index} value={version}>
                  {version}
                </option>
              ))}
            </Select>
          )}
          <Button
            colorScheme="blue"
            onClick={addNewClient}
            ml={4}
          >
            Add new PMS adapter
          </Button>
        </Flex>
        {configs.map(config => (
          <ClientTokenSettings
            key={config?._id}
            business={business}
            config={config}
            supportedPMS={supportedPMS}
            fetchClientConfig={fetchClientConfig}
            pmsSyncJob={pmsOptions?.pmsSyncJob}
          />
        ))}
      </VStack>
    </Box>
  );
};

export default PracticeManagementSoftware;
